const MAX_CARD_LIST_ITEMS = 3;

function normalizeNames(names = []) {
  return (names ?? []).map(name => String(name ?? '').trim()).filter(Boolean);
}

export function formatCardNamedList(names, { max = MAX_CARD_LIST_ITEMS } = {}) {
  let list = normalizeNames(names);
  if (!list.length) {
    return null;
  }

  let shown = list.slice(0, max);
  let overflow = list.slice(max);
  return {
    visibleText: shown.join(', '),
    overflowCount: overflow.length,
    overflowText: overflow.join(', '),
  };
}

export function formatCardPaymentList(
  insuranceProviders,
  { acceptSelfPay = false, selfPayLabel = 'Self-Pay', max = MAX_CARD_LIST_ITEMS } = {}
) {
  let list = normalizeNames(insuranceProviders);
  let selfPay = String(selfPayLabel ?? '').trim();
  if (acceptSelfPay && selfPay) {
    let already = list.some(name => name.toLowerCase() === selfPay.toLowerCase());
    if (!already) {
      list = [selfPay, ...list];
    }
  }
  return formatCardNamedList(list, { max });
}

export { MAX_CARD_LIST_ITEMS };
